import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sidebar-dashboard-layout',
  templateUrl: './sidebar-dashboard-layout.component.html',
  styleUrls: ['./sidebar-dashboard-layout.component.scss']
})
export class SidebarDashboardLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
